import { getPath } from '@/router/common'

const baseUrl = {
  title: '票据管理',
  path: 'BillManagement'
}

export default [
  {
    path: getPath('BillConsumingList76732', baseUrl),
    name: 'BillManagement_BillConsumingList76732',
    component: () => import(/* webpackChunkName: "BillManagement_BillConsumingList76732" */ '@/views/billManagement/billConsumingList76732/index.vue'),
    meta: {
      title: '票据领用'
    }
  },
  {
    path: getPath('BillReturnList76732', baseUrl),
    name: 'BillManagement_BillReturnList76732',
    component: () => import(/* webpackChunkName: "BillManagement_BillReturnList76732" */ '@/views/billManagement/billReturnList76732/index.vue'),
    meta: {
      title: '票据归还'
    }
  },
  {
    path: getPath('BillType', baseUrl),
    name: 'BillManagement_BillType',
    component: () => import(/* webpackChunkName: "BillManagement_BillType" */ '@/views/billManagement/billType/index.vue'),
    meta: {
      title: '票据类型'
    }
  },
  {
    path: getPath('BillWarehousingList', baseUrl),
    name: 'BillManagement_BillWarehousingList',
    component: () => import(/* webpackChunkName: "BillManagement_BillWarehousingList" */ '@/views/billManagement/billWarehousingList/index.vue'),
    meta: {
      title: '票据入库'
    }
  },
  {
    path: getPath('BillDistributionList', baseUrl),
    name: 'BillManagement_BillDistributionList',
    component: () => import(/* webpackChunkName: "BillManagement_BillDistributionList" */ '@/views/billManagement/billDistributionList/index.vue'),
    meta: {
      title: '票据分发'
    }
  },
  {
    path: getPath('BillCollarUseList', baseUrl),
    name: 'BillManagement_BillCollarUseList',
    component: () => import(/* webpackChunkName: "BillManagement_BillCollarUseList" */ '@/views/billManagement/billCollarUseList/index.vue'),
    meta: {
      title: '票据领用'
    }
  },
  {
    path: getPath('BillList', baseUrl),
    name: 'BillManagement_BillList',
    component: () => import(/* webpackChunkName: "BillManagement_BillList" */ '@/views/billManagement/billList/index.vue'),
    meta: {
      title: '票据列表'
    }
  },
  {
    path: getPath('BillConsumingLoad76732', baseUrl),
    name: 'BillManagement_BillConsumingLoad76732',
    component: () => import(/* webpackChunkName: "BillManagement_BillConsumingLoad76732" */ '@/views/billManagement/billConsumingLoad76732/index.vue'),
    meta: {
      title: '编辑票据领用'
    }
  },
  {
    path: getPath('BillReturnLoad76732', baseUrl),
    name: 'BillManagement_BillReturnLoad76732',
    component: () => import(/* webpackChunkName: "BillManagement_BillReturnLoad76732" */ '@/views/billManagement/billReturnLoad76732/index.vue'),
    meta: {
      title: '编辑票据归还'
    }
  },
  {
    path: getPath('AddBillType', baseUrl),
    name: 'BillManagement_AddBillType',
    component: () => import(/* webpackChunkName: "BillManagement_AddBillType" */ '@/views/billManagement/addBillType/index.vue'),
    meta: {
      title: '新增修改票据类型'
    }
  },
  {
    path: getPath('AddBillWarehousing', baseUrl),
    name: 'BillManagement_AddBillWarehousing',
    component: () => import(/* webpackChunkName: "BillManagement_AddBillWarehousing" */ '@/views/billManagement/addBillWarehousing/index.vue'),
    meta: {
      title: '票据入库'
    }
  },
  {
    path: getPath('AddBillDistribution', baseUrl),
    name: 'BillManagement_AddBillDistribution',
    component: () => import(/* webpackChunkName: "BillManagement_AddBillDistribution" */ '@/views/billManagement/addBillDistribution/index.vue'),
    meta: {
      title: '票据分发'
    }
  },
  {
    path: getPath('AddBillCollarUse', baseUrl),
    name: 'BillManagement_AddBillCollarUse',
    component: () => import(/* webpackChunkName: "BillManagement_AddBillCollarUse" */ '@/views/billManagement/addBillCollarUse/index.vue'),
    meta: {
      title: '票据领用'
    }
  },
  {
    path: getPath('BillDetail', baseUrl),
    name: 'BillManagement_BillDetail',
    component: () => import(/* webpackChunkName: "BillManagement_BillDetail" */ '@/views/billManagement/billDetail/index.vue'),
    meta: {
      title: '票据使用情况明细'
    }
  }
]
